export const BodyScroll = {
  mounted() {
    const scrollContainer = window;
    const headerElement = document.querySelector("#sticky-header");
    const path = window.location.pathname;
    const isHomepage = path === appBasePath + "/" || path === appBasePath;

    const updateHeader = () => {
      if (scrollContainer.scrollY > 10) {
        headerElement.classList.remove("border-transparent");
        headerElement.classList.add(
          "border-robe-200/50",
          "bg-robe-25/70",
          "backdrop-blur-sm",
          "is-visible",
        );
        if (isHomepage) {
          headerElement.classList.remove("light-header");
        }
      } else {
        headerElement.classList.remove(
          "border-robe-200/50",
          "bg-robe-25/70",
          "backdrop-blur-sm",
          "is-visible",
        );
        headerElement.classList.add("border-transparent");
        if (isHomepage) {
          headerElement.classList.add("light-header");
        }
      }
    };

    const handleScroll = () => {
      updateHeader();
      window.updateNavIconColors(); //root.html.heex
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    handleScroll();

    this.destroy = () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  },

  destroyed() {
    if (this.destroy) {
      this.destroy();
    }
  },
};
